var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svgicon',{class:( _obj = {}, _obj[_vm.$options.name] = true, _obj[("" + _vm.positioning)] = _vm.positioning, _obj ),attrs:{"name":_vm.name,"original":_vm.original,"width":_vm.width,"height":_vm.height,"color":_vm.color}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fe5c635","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/base-icon/BaseIcon.vue
// module id = null
// module chunks = 